
const get = (state) => state.session.details;
const isLoading = (state) => state.session.loading;
const isError = (state) => state.session.error;


export const SessionSelectors = {
  get,
  isLoading,
  isError
}
